import React from "react";
import PropTypes from "prop-types";
import TwoPaneMultiSelectContainer
    from "lib/common/twopanemultiselect/TwoPaneMultiSelectContainer";
import asModal from "lib/modal/asModal";

const HiddenFieldAdminModal = ({
                                   triggerClose,
                                   triggerSave,
                               }) =>
    <TwoPaneMultiSelectContainer
        triggerClose={triggerClose}
        triggerSave={triggerSave}
        contentBlocks={{
            header: "Please select the fields you would like to hide within data entry.",
            unselectedPane: "Available Fields",
            selectIcon: "Hide",
            selectedPane: "Hidden Fields",
            unselectIcon: "Show",
            footer: "* only applies to a subset of versions",
        }}
    />;

HiddenFieldAdminModal.propTypes = {
    triggerClose: PropTypes.func.isRequired,
    triggerSave: PropTypes.func.isRequired,
};

export default asModal("Hidden Fields Administration")(HiddenFieldAdminModal);



// WEBPACK FOOTER //
// ./app/lib/hiddenFields/HiddenFieldAdminModal.js